import { PreferenceKeys, PreferencesService } from 'processes/Preferences';

export function switchToPrivate(preferencesService: PreferencesService) {
  return window.location.href = preferencesService.get(PreferenceKeys.ACCOUNT_URL)
}